// /home/ananun/fluorescence.pro/admin/src/components/debt-repayment/debtRepayment.jsx
// debtRepayment.jsx

import React, { useState, useEffect, useMemo } from "react";
import SinglePage from "../SinglePage";
import { useParams, useLocation } from "react-router-dom";
import * as API from "../../helpers/api";
import { isDraftMode } from "../../helpers/ensureDraftOnAdd";
import config from "../../config";
import Loading from "../modules/loading";
import { useUser } from "../../helpers/userContext";
import moment from "moment";
import parse from "html-react-parser";
import { useLang } from "../../helpers/language";
import NProgress from "nprogress";

export default function DebtRepayment() {
	const [isBusy, setBusy] = useState(true);
	let id = useParams().id;
	const route = config.api.debtRepayment;
	const { lang } = useLang();
	const { user } = useUser();
	const location = useLocation();
	const [permissions, setPermissions] = useState([]);

	const [ID, setID] = useState("");

	const [amount, setAmount] = useState(0);
	const [date, setDate] = useState(new Date());
	const [client, setClient] = useState("");
	const [allClients, setAllClients] = useState([]);
	const [allOrders, setAllOrders] = useState([]);
	const [desc, setDesc] = useState("");

	const modelSendToServer = {
		ID,
		amount,
		client,
		date,
		desc,
	};

	useEffect(() => {
		(async () => {
			NProgress.start();
			// all clients
			let clients = [];

			try {
				clients = await API.get(config.api.client, {});
				setAllClients(clients);
			} catch (error) {
				console.log(error);
			}

			let rawID = [];
			try {
				rawID = await API.get(route, { temporary: { $ne: true } }, { ID: "desc" }, {}, 1);
			} catch (error) {
				console.log(error);
			}

			if (id !== "add" && !isDraftMode(location.search)) {
				let currentItem = await API.get(route, {
					_id: id,
				});

				setID(
					currentItem[0]?.ID ? currentItem[0]?.ID : rawID[0]?.ID ? rawID[0]?.ID + 1 : 1
				);
				setClient(currentItem[0]?.client);
				currentItem[0]?.date && setDate(new Date(currentItem[0]?.date));
				setDesc(currentItem[0]?.desc ? currentItem[0]?.desc : "");
				setAmount(currentItem[0]?.amount);
			} else {
				setID(rawID[0]?.ID ? rawID[0]?.ID + 1 : 1);
			}
			setBusy(false);
		})();
		// eslint-disable-next-line
	}, [isBusy]);

	useEffect(() => {
		let tempPermissions = [];
		user?.role?.permissions?.forEach((permission) => {
			if (permission.name === "client") {
				permission.inputs.forEach((input) => {
					tempPermissions.push(input);
				});
			}
		});
		setPermissions([...tempPermissions]);
	}, []);

	if (isBusy) return <Loading />;
	else
		return (
			<SinglePage
				isBusy={isBusy}
				setBusy={setBusy}
				route={route}
				id={id}
				permissions={permissions}
				permissionModel="debt-repayment"
				modelSendToServer={modelSendToServer}
				inputs={[
					{
						value: ID,
						setter: setID,
						type: "number",
						usageType: "number",
						label: "ID",
						permissionModel: "ID",
					},
					{
						value: client,
						setter: setClient,
						type: "optionlist",
						usageType: "optionlist",
						optionListValue: allClients.map(
							(client) => ({
								value: client._id,
								label: client.name,
							}),
							[]
						),
						label: config.translate.client[lang],
						placeholder: config.translate.client[lang],
						permissionModel: "client",
					},
					{
						value: amount,
						setter: setAmount,
						type: "number",
						usageType: "number",
						label: config.translate.price[lang],
						placeholder: config.translate.price[lang],
						permissionModel: "amount",
					},
					{
						value: date,
						setter: setDate,
						type: "datePicker",
						usageType: "datePicker",
						label: config.translate.date[lang],
						placeholder: config.translate.date[lang],
						permissionModel: "date",
					},
					{
						value: desc,
						setter: setDesc,
						type: "textarea-simple",
						usageType: "textarea-simple",
						label: config.translate.desc[lang],
						placeholder: config.translate.desc[lang],
						permissionModel: "desc",
					},
				]}
			/>
		);
}
